import ReactDOM from 'react-dom';
import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import VButton from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import './modalMultiAccounts.css';
import apiService from 'Services/apiService';
import AlertNotification, { IAlert } from "components/common/AlertNotification/AlertNotification";

function MultiAccounts({ show, switchT }: IModal) {

  const [alert, setAlert] = useState<IAlert>({ show: false, title: '', details: '', variant: 'Danger' });
  const [disableBtn, setDisableBtn] = useState<boolean>(false);
  const [validated, setValidated] = useState(false);
  const [account, setAccount] = useState('');
  const [clients, setClients] = useState<any[]>([]); // Almacenar array_client

  useEffect(() => {
    if (show) {
      // Obtener el array_client del localStorage cuando se carga el componente
      const arrayClients = JSON.parse(localStorage.getItem('arrC') || '{}');
      if (arrayClients) {
        setClients(arrayClients);
        setAccount(arrayClients[0]._codigoCliente);
      }
    }
  }, [show]);

  const handleSubmit = (event: any) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    if (form.checkValidity() === false) {
      setValidated(true);
    } else {
      switchT(account);
    }
  };

  const resetAlert = () => {
    setAlert(prev => ({ ...prev, show: false }));
  };

  const handleAccountsChange = (event: any) => {
    setAccount(event.target.value);
  };

  return (
    <>
      <Modal
        show={show}
        dialogClassName="modal-md"
        className="modalMultiAccounts p-3"
        aria-labelledby="modal-multi-accounts"
        centered
      >
        <Modal.Header className='p-3 px-4'>
         <h5>Elige un perfil para continuar</h5>
        </Modal.Header>

        <Modal.Body className='p-3 px-4'>
          <section>
            <p className='mb-1'>Tienes acceso a múltiples perfiles en esta plataforma.</p>
            <p>Selecciona el perfil con el que deseas continuar para acceder a la información personalizada.</p>
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <Row className="mb-3">
                <Form.Group as={Col} controlId="validationCustom01" className="noFeedback">
                  <Form.Label><small><b>Perfiles disponibles <span className="text-danger">•</span></b></small></Form.Label>
                  <Form.Select
                    required
                    onChange={handleAccountsChange}
                    value={account}
                  >
                    {clients.map(client => (
                      <option key={client._id} value={client._codigoCliente}>
                        {client._nombre}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">Este campo es requerido.</Form.Control.Feedback>
                </Form.Group>
              </Row>
              <div className="d-flex justify-content-end border-top">
                <VButton className="primary-bg-btn px-3 py-2 mt-2" type="submit" disabled={disableBtn}>
                  {disableBtn && <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>} Continuar
                </VButton>
              </div>
            </Form>
          </section>
        </Modal.Body>

        <AlertNotification
          show={alert?.show}
          title={alert?.title}
          details={alert?.details}
          variant={alert?.variant}
          onClose={resetAlert}
        />
      </Modal>
    </>
  );
}

export default function ModalMultiAccounts({ show, switchT }: IModal) {

  const modalRoot = document.getElementById('modal-root') as HTMLElement;

  return ReactDOM.createPortal(
    <MultiAccounts
      show={show}
      switchT={switchT}
    />,
    modalRoot
  );
}

interface IModal {
  show: boolean;
  switchT: (clientCode: string) => void;
}
